<template>
  <v-container class="pa-6">
    <h1 class="title mb-4">Export des données</h1>
    <p>Récupérez les données de votre organisation en CSV et vos documents dans une archive ZIP. Un email vous sera envoyé lorsque l’archive sera prête.</p>
    <v-alert v-if="message" type="info">{{ message }}</v-alert>
    <v-alert v-if="error" type="error">{{ error }}</v-alert>
    <div class="d-flex justify-end align-center flex-wrap">
      <v-btn text class="mr-2 mb-2" :loading="loading" :disabled="requesting" @click="load">Actualiser</v-btn>
      <v-btn color="primary" class="mb-2" :loading="requesting" :disabled="loading || hasActive || requesting" @click="requestExport">Demander un export</v-btn>
    </div>
    <v-data-table class="mt-5" :headers="headers" :items="items" :loading="loading" :items-per-page="25" no-data-text="Aucun export demandé">
      <template v-slot:item.requestedAt="{ item }">{{ date(item.requestedAt) }}</template>
      <template v-slot:item.finishedAt="{ item }">{{ date(item.finishedAt) }}</template>
      <template v-slot:item.archiveExpiresAt="{ item }">{{ date(item.archiveExpiresAt) }}</template>
      <template v-slot:item.requesterName="{ item }">{{ item.requesterName || item.requesterEmail }}</template>
      <template v-slot:item.status="{ item }">{{ labels[item.status] || item.status }}</template>
      <template v-slot:item.download="{ item }">
        <v-btn v-if="item.status === `done`" color="primary" :loading="downloading === item.id" @click="download(item)">Télécharger</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import api from '@/api';

export default {
  data: () => ({
    items: [],
    loading: false,
    requesting: false,
    downloading: null,
    error: ``,
    message: ``,
    labels: {
      queued: `En cours`, inProgress: `En cours`, done: `Disponible`, failed: `Échec`, expired: `Expiré`,
    },
    headers: [
      { text: `Demandé le`, value: `requestedAt` }, { text: `Demandé par`, value: `requesterName` },
      { text: `Statut`, value: `status` }, { text: `Terminé le`, value: `finishedAt` },
      { text: `Expiration`, value: `archiveExpiresAt` }, { text: `Archive`, value: `download`, sortable: false },
    ],
  }),
  computed: {
    clientId() { return this.$store.state[`model/client`].company.id; },
    hasActive() { return this.items.some(item => [`queued`, `inProgress`].includes(item.status)); },
  },
  mounted() { this.load(); },
  methods: {
    date(value) { return value ? new Date(value).toLocaleString(`fr-FR`) : `—`; },
    async load() {
      this.loading = true;
      this.error = ``;
      try {
        const items = [];
        let total = 0;
        do {
          const { data } = await api.get(`/data-exports/client/${this.clientId}`, { params: { limit: 100, offset: items.length } });
          items.push(...data.items);
          total = data.total;
          if (!data.items.length) break;
        } while (items.length < total);
        this.items = items;
      } catch (e) { this.error = `Impossible de charger les exports. Veuillez réessayer.`; } finally { this.loading = false; }
    },
    async requestExport() {
      if (this.requesting || this.hasActive) return;
      this.requesting = true;
      this.error = ``;
      try {
        const { data } = await api.post(`/data-exports/client/${this.clientId}`);
        this.items = [data.export, ...this.items.filter(item => item.id !== data.export.id)];
        this.message = data.reason === `alreadyUpToDate`
          ? `Votre dernier export contient déjà toutes vos données à jour. Vous pouvez le télécharger.`
          : `Votre export est en cours de préparation. Vous recevrez un email lorsqu’il sera disponible.`;
      } catch (e) { this.error = `Impossible de demander l’export. Veuillez actualiser puis réessayer.`; } finally { this.requesting = false; }
    },
    async download(item) {
      this.downloading = item.id;
      this.error = ``;
      try {
        const { data } = await api.get(`/data-exports/${item.id}/link`);
        window.location.assign(data.url);
      } catch (e) { this.error = `Archive indisponible. Actualisez la liste ou demandez un nouvel export.`; } finally { this.downloading = null; }
    },
  },
};
</script>
